export default __webpack_public_path__ + "static/media/blackmike.ac24bd9e.svg";